// extracted by mini-css-extract-plugin
export default {"MenuItem":"style_MenuItem__Jmmwu"};